import { colors } from "../../Styles";

export function Minus({size = "20px", transparency = 1, fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} opacity={transparency} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <rect x="14.17" y="119.83" width="255.12" height="43.81" rx="13.22" ry="13.22"/>
    </svg>
  );
}
